/* eslint-disable complexity */
import { type Space, bytesToNDigits } from '@mail/cross-sizes-utils';
import { autoUploadPromo } from 'reactApp/appHelpers/featuresHelpers/features/autoUploadPromo';
import { isMinTariffsWithAds } from 'reactApp/appHelpers/featuresHelpers/features/minTariffsWithAds';
import { familyByOptionsFeatureMobile } from 'reactApp/appHelpers/featuresHelpers/features/multiTariffMobile';
import {
    isShowEditingDocumentFeatureEnabled,
    SHOW_EDITING_DOCUMENT_SHORT_FEATURE_TEXT,
} from 'reactApp/appHelpers/featuresHelpers/features/showEditingDocumentFeature';
import { SPACE_LIST } from 'reactApp/constants/spaceList';
import { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';

const duplucateRemove = 'Удаление дубликатов';

const getFeaturesModalData = (uploadLimit: number) => [
    'Больше места для файлов',
    'Никакой рекламы в Почте и Облаке',
    `Загрузка файлов до ${bytesToNDigits(uploadLimit, 3).value}`,
    'Автоудаление отправленных файлов',
    'Автосохранение файлов с телефона',
    'Онлайн-доступ с любого устройства',
    'Отмена письма в течение 20 секунд',
    'Виджеты Календаря и Задач на виду',
    'Проверка вложений антивирусом',
    'Отдельные папки для рассылок и\u00A0чеков',
    'Приоритетная поддержка',
];

const getForWorkFeaturesModalData = (uploadLimit: number) => [
    'Редактирование документов',
    'Автосохранение файлов с\u00A0телефона в\u00A0Облако',
    'Дополнительное место для файлов',
    'Безлимитная автозагрузка фото и\u00A0видео с\u00A0телефона',
    'Приоритетная поддержка',
    'Без\u00A0рекламы',
    `Загрузка файлов до\u00A0${bytesToNDigits(uploadLimit, 3).value}\u00A0в\u00A0Облако`,
    'Таймер для\u00A0автоудаления отправленных папок',
    'Выбор оформления для\u00A0совместных папок',
    'Установка пароля для\u00A0совместных папок в\u00A0веб-версии',
    'Определение лиц\u00A0на\u00A0фото',
    'Разбор фото свайпами',
    duplucateRemove,
    'Дополнительное место для\u00A0писем',
    `Отправка вложений до\u00A0${bytesToNDigits(uploadLimit, 3).value}\u00A0в\u00A0письмах`,
    'Проверка вложений антивирусом',
    'Полезные виджеты Календаря\u00A0и\u00A0Задач всегда на\u00A0виду',
    'Отмена отправки писем в\u00A0течение 30\u00A0секунд',
    'Уведомления о\u00A0прочтении ваших писем',
    'Красивый адрес',
    'Нейропомощник в\u00A0веб-версии',
    'Возможность заходить с\u00A03\u00A0и\u00A0более компьютеров',
    'Краткий пересказ писем',
    'Генерация и\u00A0изменение стиля писем',
];

const UNLIMITED_AUTOUPLOAD = 'Безлимитная автозагрузка фото и видео с\u00A0телефона';

interface FeatureModalListProps {
    space?: Space;
    isFamily?: boolean;
    isMultiTariff?: boolean;
    activeTab?: ETabsName;
    uploadLimit: number;
}

export const getFeaturesModalList = ({ space, isFamily, activeTab, isMultiTariff, uploadLimit }: FeatureModalListProps) => {
    const features = [...getFeaturesModalData(uploadLimit)];
    const uploadText = `Загрузка файлов до ${bytesToNDigits(uploadLimit, 3).value}`;

    // tempexp_19902-start
    const removeAds =
        (isMinTariffsWithAds && space && space?.original <= SPACE_LIST.gb_128) || (isMultiTariff && activeTab === ETabsName.basic);

    if (removeAds) {
        features.splice(1, 1);
        return features;
    }
    // tempexp_19902-end

    if (familyByOptionsFeatureMobile) {
        if (autoUploadPromo && space && space?.original >= SPACE_LIST.gb_256) {
            features.splice(2, 0, UNLIMITED_AUTOUPLOAD);
        }

        if (isFamily) {
            const insertIndex = features.indexOf(UNLIMITED_AUTOUPLOAD) + 1;
            features.splice(insertIndex, 0, 'Безлимит и отключение рекламы у всех в подписке');
            features.splice(insertIndex, 0, 'Семейный календарь');
            features.splice(insertIndex, 0, 'Распознавание документов семьи');
            features.splice(insertIndex, 0, 'Семейные папки и альбомы');
            features.splice(insertIndex, 0, 'Добавление в подписку до 3 близких');
            features.splice(insertIndex, 0, 'Можно делиться памятью ещё с 3 участниками');
        }

        if (space && space?.original >= SPACE_LIST.gb_256) {
            const uploadIndex = features.indexOf(uploadText);
            features.splice(uploadIndex, 0, duplucateRemove);
        }
    } else {
        if (autoUploadPromo && space && space?.original >= SPACE_LIST.gb_256) {
            features.splice(2, 0, UNLIMITED_AUTOUPLOAD);
        }

        if (space && space?.original >= SPACE_LIST.gb_256) {
            features.splice(1, 0, duplucateRemove);
        }

        if (isFamily) {
            const uploadIndex = features.indexOf(uploadText);
            features.splice(uploadIndex + 1, 0, 'Добавление в подписку до 3 близких');
            features.splice(uploadIndex + 2, 0, 'Семейные папки и альбомы');
        }
    }

    if (isShowEditingDocumentFeatureEnabled && space && space?.original >= SPACE_LIST.gb_512) {
        return [...features, SHOW_EDITING_DOCUMENT_SHORT_FEATURE_TEXT];
    }

    if (activeTab === ETabsName.for_work) {
        return [...getForWorkFeaturesModalData(uploadLimit)];
    }

    return features;
};
